import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class Nodes extends RestApiModel {
  static getResourceEndpoint() {
    return '/content-management/nodes';
  }

  /**
   * @param id
   * @param isEnabled
   * @returns {*}
   */
  static localizationOptions() {
    return api.get(`${this.getResourceEndpoint()}/localization-options`);
  }
}

export default Nodes;
